"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StuffCard = void 0;
var lit_html_1 = require("lit-html");
var async_replace_js_1 = require("lit-html/directives/async-replace.js");
var solid_ui_1 = require("solid-ui");
var baseStyles_1 = require("./baseStyles");
var style_map_js_1 = require("lit-html/directives/style-map.js");
var baseStyles_2 = require("./baseStyles");
var dom = document;
var styles = {
    image: (0, style_map_js_1.styleMap)((0, baseStyles_1.fullWidth)()),
    intro: (0, style_map_js_1.styleMap)(__assign(__assign({}, (0, baseStyles_1.textGray)()), (0, baseStyles_1.textCenter)())),
    card: (0, style_map_js_1.styleMap)((0, baseStyles_2.card)()),
    info: (0, style_map_js_1.styleMap)(__assign(__assign({}, (0, baseStyles_1.paddingSmall)()), (0, baseStyles_1.textLeft)())),
};
var StuffCard = function (profileBasics, context, subject, stuffData) {
    var stuff = stuffData.stuff;
    var nameStyle = (0, style_map_js_1.styleMap)(__assign(__assign({}, (0, baseStyles_1.heading)()), { 
        // "text-decoration": "underline",
        color: profileBasics.highlightColor }));
    // return renderThings(stuff)
    return (0, lit_html_1.html)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  <div>\n    <div data-testid=\"stuff\" style=\"", "\">\n      <div style=", ">\n        <h3 style=", ">Stuff</h3>\n\n        <div style=", "><table data-testid=\"stuffTable\">", "</table></div>\n        <hr />\n\n      </div>\n    </div>\n  </div>\n"], ["\n  <div>\n    <div data-testid=\"stuff\" style=\"", "\">\n      <div style=", ">\n        <h3 style=", ">Stuff</h3>\n\n        <div style=", "><table data-testid=\"stuffTable\">", "</table></div>\n        <hr />\n\n      </div>\n    </div>\n  </div>\n"])), styles.card, styles.info, nameStyle, styles.info, renderThings(stuff));
};
exports.StuffCard = StuffCard;
function renderThingAsDOM(thing, dom) {
    var options = {};
    var row = solid_ui_1.widgets.personTR(dom, null, thing.instance, options);
    return row;
}
function renderThing(thing, dom) {
    return renderThingAsDOM(thing, dom);
    return (0, lit_html_1.html)(templateObject_2 || (templateObject_2 = __makeTemplateObject([" ", " "], [" ", " "])), (0, async_replace_js_1.asyncReplace)(renderThingAsDOM(thing, dom)));
}
function renderThings(things) {
    // console.log('Renderthings: ', things)
    if (things.length === 0)
        return (0, lit_html_1.html)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
    return (0, lit_html_1.html)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", "", ""], ["", "", ""])), renderThing(things[0], dom), things.length > 1 ? renderThings(things.slice(1)) : (0, lit_html_1.html)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""]))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
// ENDS
//# sourceMappingURL=StuffCard.js.map